import React from 'react';
import { Button } from './ui/Button';
import { BookOpen, Eye, PenTool } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-16 px-4 border-t border-gray-200" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <div className="text-center mb-12" data-id="element-142">
          <span className="inline-block bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-sm mb-4 tracking-wide" data-id="element-143">
            ✅ LA SOLUCIÓN DEFINITIVA
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-144">
            MegaPack Mecánica Preventiva para No Mecánicos
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-145">
            Un sistema completo, claro y paso a paso, diseñado para que
            cualquier persona pueda cuidar su vehículo, anticiparse a los
            problemas y tomar mejores decisiones,{' '}
            <span className="font-bold" data-id="element-146">
              sin ser mecánico ni ensuciarse las manos.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-147">
          <div className="bg-blue-50 p-6 rounded-xl text-center border border-blue-100 shadow-sm" data-id="element-148">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-149">
              <BookOpen className="w-8 h-8 text-blue-600" data-id="element-150" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-151">📂 Abrís el material</h3>
            <p className="text-gray-600 text-sm" data-id="element-152">
              Acceso inmediato a todo el conocimiento organizado.
            </p>
          </div>
          <div className="bg-blue-50 p-6 rounded-xl text-center border border-blue-100 shadow-sm" data-id="element-153">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-154">
              <Eye className="w-8 h-8 text-blue-600" data-id="element-155" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-156">
              👀 Identificás el problema
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-157">
              Sin dudas, sabiendo exactamente qué buscar.
            </p>
          </div>
          <div className="bg-blue-50 p-6 rounded-xl text-center border border-blue-100 shadow-sm" data-id="element-158">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-159">
              <PenTool className="w-8 h-8 text-blue-600" data-id="element-160" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-161">✍️ Sabés qué hacer</h3>
            <p className="text-gray-600 text-sm" data-id="element-162">
              Tomás acción o hablás con el mecánico con autoridad.
            </p>
          </div>
        </div>

        <div className="bg-gray-900 text-white p-6 rounded-xl text-center mb-12 shadow-xl" data-id="element-163">
          <p className="text-xl md:text-2xl font-bold" data-id="element-164">
            Sin improvisar. Sin miedo. Sin que te pasen por arriba.
          </p>
        </div>

        <div className="text-center" data-id="element-165">
          <Button variant="secondary" className="text-lg px-12" data-id="element-166">
            🚀 QUIERO DEJAR DE GASTAR DE MÁS
          </Button>
        </div>
      </div>
    </section>;
}